import { useState } from "react";
import moment from "moment";

import { REQUEST_STATUS_BG, REQUEST_STATUS_LABEL } from "../constants/status";
import { EXPORT_COLUMN_HEADERS, EXPORT_COLUMN_KEYS } from "../constants/columns";

import { useCurrentCompany } from "../../../../../hooks/useCurrentCompany";

import {
  appName,
  formatDateForExcelHeader,
  sortArray,
} from "../../../../../utils/excelUtils";

import { downloadFileBase64 } from "../../../../../utils/utils";

import { getDateTime } from "../../../../Queries/components/utils";

const wchCols = Object.values(EXPORT_COLUMN_KEYS).map((value) => ({
  wch: value.length + 20,
}));

const formatDate = (date) => moment.utc(date).format("DD/MM/YYYY");

const processData = (rowsToBeExported) => {
  const transformedRows = rowsToBeExported.map((cell) => {
    const cellObj = {};

    Object.keys(cell).forEach((key) => {
      let statusCellBg;
      const isStatusKey = key === "status";

      if (isStatusKey) {
        const statusBg = REQUEST_STATUS_BG[cell[key]];
        statusCellBg = statusBg.match(/#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})/)?.[1];
      }

      const item = {
        value: !isStatusKey ? cell[key] : REQUEST_STATUS_LABEL[cell[key]],
        style: {
          ...(!isStatusKey
            ? {}
            : {
                fill: statusCellBg,
              }),
          horizontalAlignment: "center",
          verticalAlignment: "bottom",
        },
      };

      cellObj[key] = item;
    });

    return cellObj;
  });

  return transformedRows;
};

const dataToExcel = (dataToExport, sortConfig, companyName) => {
  const data = sortArray(dataToExport, sortConfig[0]);

  const dataExcel = data.map(({ startDate, endDate, ...rest }) => ({
    ...rest,
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  }));

  const toExcel = {
    filename: "Solicitudes",
    templateFileName: "simple_template.xlsx",
    replace: [
      {
        type: 0,
        tag: "#simple.name",
        prop: "name",
        default: "Simple",
      },
      {
        type: 1,
        tag: "#simple.company",
        prop: "company",
        default: "Simple",
      },
      {
        type: 1,
        tag: "#printDate",
        prop: "printDate",
        default: new Date().toLocaleDateString(),
        format: ["numberFormat", "dd mmmm yyyy"],
      },
      {
        type: 1,
        tag: "#simple.appName",
        prop: "appName",
        default: "Simple",
      },
      {
        type: 1,
        tag: "#simple.name",
        prop: "name",
        default: "Simple",
      },
      {
        type: 2,
        tag: "#simple.cols",
        prop: "cols",
      },
      {
        type: 4,
        tag: "#simple.rows",
        prop: "rows",
        colprop: "cols",
        default: "N/D",
      },
    ],
    data: {
      company: companyName,
      autoFilter: true,
      gridLinesVisible: true,
      printDate: formatDateForExcelHeader(new Date()),
      appName: appName,
      name: "Solicitudes",
      cols: [],
      rows: processData(dataExcel),
    },
  };

  Object.values(EXPORT_COLUMN_KEYS).forEach((header, index) => {
    const col = {
      title: EXPORT_COLUMN_HEADERS[header],
      prop: header,
      width: wchCols[index].wch,
    };

    toExcel.data.cols.push(col);
  });

  return toExcel;
};

export const useExportToExcel = () => {
  const companyInfo = useCurrentCompany();

  const [isExporting, setIsExporting] = useState(false);

  const exportToExcel = async ({ data, sortConfig }) => {
    try {
      setIsExporting(true);

      const toExcel = dataToExcel(data, sortConfig, companyInfo?.name);

      const dateName = getDateTime();

      await downloadFileBase64(toExcel, "xlsx", `Solicitudes_${dateName}`);
    } finally {
      setIsExporting(false);
    }
  };

  return { exportToExcel, isExporting };
};
